import {isNotNil} from 'ramda';

import {useGetRentalVehicleQuery} from '@dms/api/vehicle';
import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';
import {Main, PageTab, useIsLicenceEnabled, usePricePermissions} from '@dms/shared';

import {buildArray, composePath, useRequiredParams} from 'shared/web';

import {VehicleEarningsAndCosts} from './components/VehicleEarningsAndCosts';
import {VehiclePrices} from './components/VehiclePrices';
import {VehicleRentalPrices} from './components/VehicleRentalPrices';

export function PricesAndFinances() {
  const {id: vehicleId} = useRequiredParams();

  const {data: rentalVehicle} = useGetRentalVehicleQuery({vehicleId});
  const hasRentalVehicle = isNotNil(rentalVehicle);

  const {canViewAnyOfVehiclePriceFields, canReadVehicleCosts, canReadVehicleEarnings} =
    usePricePermissions({vehicleRecordId: vehicleId, businessCaseRecordId: null});

  const {isSalesModuleEnabled, isRentalVehicleModuleEnabled} = useIsLicenceEnabled();

  return (
    <Main
      data-testid={testIds.vehicles.finances('page')}
      tabs={buildArray<PageTab>()
        .when(canViewAnyOfVehiclePriceFields && isSalesModuleEnabled, {
          id: 'prices',
          title: i18n.t('entity.vehicle.labels.carPrices'),
          href: composePath(vehiclesRoutes.financesPrices, {params: {id: vehicleId}}),
          content: <VehiclePrices />,
        })
        .when(canReadVehicleCosts || canReadVehicleEarnings, {
          id: 'earningsCosts',
          title: i18n.t('page.vehicle.labels.earningsCosts'),
          href: composePath(vehiclesRoutes.financesEarningsCosts, {params: {id: vehicleId}}),
          content: <VehicleEarningsAndCosts />,
        })
        .when(hasRentalVehicle && isRentalVehicleModuleEnabled, {
          id: 'rentalEarningsCosts',
          title: i18n.t('entity.rental.labels.rentalPrices'),
          href: composePath(vehiclesRoutes.financesRentalPrices, {params: {id: vehicleId}}),
          content: <VehicleRentalPrices />,
        })}
    />
  );
}
